import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import Trand_1 from '../../../assets/images/product/01.png';
import Trand_2 from '../../../assets/images/product/02.png';
import Trand_3 from '../../../assets/images/product/03.png';
import Trand_4 from '../../../assets/images/product/04.png';
import Trand_5 from '../../../assets/images/product/05.png';
import Trand_6 from '../../../assets/images/product/06.png';

const products = [
    {
        id: 1,
        image: Trand_1,
        title: 'Wood Cutting Chair',
        price: '$256.00',
        rating: 4.8,
        reviews: 1248,
        badge: 'New Arrival',
    },
    {
        id: 2,
        image: Trand_2,
        title: 'Smart T-Table Wooden',
        price: '$100.00',
        rating: 4.8,
        reviews: 1248,
        discount: '-20%',
    },
    {
        id: 3,
        image: Trand_3,
        title: 'Jamping Chair Premium',
        price: '$260.00',
        rating: 4.8,
        reviews: 1248,
    },
    {
        id: 4,
        image: Trand_4,
        title: 'Wooden Chair mini',
        price: '$120.00',
        rating: 4.8,
        reviews: 850,
    },
    {
        id: 5,
        image: Trand_5,
        title: 'Wood Cutting Chair',
        price: '$256.00',
        rating: 4.8,
        reviews: 1248,
    },
    {
        id: 6,
        image: Trand_6,
        title: 'Wood Cutting Chair',
        price: '$256.00',
        rating: 4.8,
        reviews: 1248,
    },
];

const trandSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            },
        },
    ],
};

const Tranding = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [sortBy, setSortBy] = useState("Recommended");
    const dropdownRef = useRef(null);


    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSortChange = (sortOption) => {
        setSortBy(sortOption);
        setIsDropdownOpen(false);
        
    };

    return (
        <section id="trending" className="trending-main-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6">
                        <div className="section">
                            <h2 className="section-heading">Trending Now</h2>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="dropdown-btn text-end" ref={dropdownRef}>
                            <button
                                className="btn btn-secondary dropdown-toggle"
                                type="button"
                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                            >
                                Sort by: <span className="sort">{sortBy}</span>
                                <i className="flaticon-down-arrow" />
                            </button>

                            {isDropdownOpen && (
                                <ul className="dropdown-menu show" style={{ position: 'relative', display: 'inline-block', top: -60 }}>
                                    <li>
                                        <Link className="dropdown-item" to="#" onClick={() => handleSortChange("Recommended")}>
                                            Recommended
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="#" onClick={() => handleSortChange("Price: Low to High")}>
                                            Name
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="#" onClick={() => handleSortChange("Price: High to Low")}>
                                            Date
                                        </Link>
                                    </li>
                                </ul>
                            )}
                        </div>
                    </div>
                </div>
                <Slider className="slider trending-autoplay" {...trandSettings} dots='true'>
                    {products.map(product => (
                        <div key={product.id} className="trending-block">
                            <div className="trending-product-block">
                                <div className="trending-product-img-badge">
                                    {product.badge && <span className="badge badge-one">{product.badge}</span>}
                                    <div className="heart-icon">
                                        <Link to="#" title="">
                                            <i className="flaticon-love" />
                                        </Link>
                                    </div>
                                    <div className="trending-product-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={product.image}
                                                className="img-fluid"
                                                alt={product.title}
                                            />
                                        </Link>
                                    </div>
                                    <ul className="trending-icons">
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-search-interface-symbol" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-bag" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-reload" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="trending-product-dtls">
                                    <div className="row">
                                        <div className="col-lg-8 col-8">
                                            <h5 className="trending-product-title">
                                                <Link to="/ShopDetails" title="">
                                                    {product.title}
                                                </Link>
                                            </h5>
                                            <p className="rate">{product.price}</p>
                                        </div>
                                        <div className="col-lg-4 col-4">
                                            <div className="trending-product-rating">
                                                <span className="badge badge-two">
                                                    {product.rating}
                                                    <i className="flaticon-star" />
                                                </span>
                                                <p className="review">({product.reviews})</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
                <Slider className="slider trending-autoplay" {...trandSettings}>
                    {products.map(product => (
                        <div key={product.id} className="trending-block">
                            <div className="trending-product-block">
                                <div className="trending-product-img-badge">
                                    {product.badge && <span className="badge badge-one">{product.badge}</span>}
                                    <div className="heart-icon">
                                        <Link to="#" title="">
                                            <i className="flaticon-love" />
                                        </Link>
                                    </div>
                                    <div className="trending-product-img">
                                        <Link to="/ShopDetails" title="">
                                            <img
                                                src={product.image}
                                                className="img-fluid"
                                                alt={product.title}
                                            />
                                        </Link>
                                    </div>
                                    <ul className="trending-icons">
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-search-interface-symbol" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-bag" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                <i className="flaticon-reload" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="trending-product-dtls">
                                    <div className="row">
                                        <div className="col-lg-8 col-8">
                                            <h5 className="trending-product-title">
                                                <Link to="/ShopDetails" title="">
                                                    {product.title}
                                                </Link>
                                            </h5>
                                            <p className="rate">{product.price}</p>
                                        </div>
                                        <div className="col-lg-4 col-4">
                                            <div className="trending-product-rating">
                                                <span className="badge badge-two">
                                                    {product.rating}
                                                    <i className="flaticon-star" />
                                                </span>
                                                <p className="review">({product.reviews})</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default Tranding;